<div
  class="bg-red-90 hover:bg-grey-90 flex cursor-pointer items-center gap-x-2 rounded-full px-2.5 py-1.5 text-white transition-colors"
  [ngClass]="{
    'pl-4': count && count > 0,
    'border-grey-80/80 border bg-transparent': count === 0,
  }">
  @if (count && count > 0) {
    <span class="text-xs">{{ count }}</span>
  }
  <t-icon key="notifications-active" size="small" color="inherit"></t-icon>
</div>
